import { useEffect, useState } from 'react';
import WebApp from '@twa-dev/sdk';

export const useTelegram = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    WebApp.ready();
    WebApp.expand();
    if ((WebApp as any).disableVerticalSwipes) {
      (WebApp as any).disableVerticalSwipes();
    }
    setIsReady(true);

    WebApp.setHeaderColor('#FFFFFF');
    WebApp.setBackgroundColor('#FFFFFF');
  }, []);

  const openLink = (url: string) => {
    WebApp.openLink(url);
  };

  const openTelegramLink = (url: string) => {
    WebApp.openTelegramLink(url);
  };

  const showAlert = (message: string) => {
    WebApp.showAlert(message);
  };

  const showConfirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      WebApp.showConfirm(message, resolve);
    });
  };

  const close = () => {
    WebApp.close();
  };

  const user = WebApp.initDataUnsafe?.user;

  return {
    isReady,
    user,
    openLink,
    openTelegramLink,
    showAlert,
    showConfirm,
    close,
    webApp: WebApp,
  };
};
